import type { ISimulationPlanningCard } from '@/types';

export interface SimulationScenarioSlideoutModalProps {
  activeCard: ISimulationPlanningCard | null;
  animatingStepId: number | null;
  isOpen: boolean;
  onClose: () => void;
  onComplete?: () => void;
  onNext: () => void;
  onPrevious: (stepId?: number) => void;
  planningCards?: ISimulationPlanningCard[];
}

export type StepStatus = 'completed' | 'active' | 'upcoming';

export const MODAL_BODY_HORIZONTAL_PADDING_REM = 1.5;
